import Hero from "../sections/Hero";
import TrustStrip from "../sections/TrustStrip";
import AboutSection from "../sections/AboutSection";
import ServicesSection from "../sections/ServicesSection";
import CapabilitiesSection from "../sections/CapabilitiesSection";
import QualitySection from "../sections/QualitySection";
import CommitmentSection from "../sections/CommitmentSection";
import ClientsSection from "../sections/ClientsSection";
import { CTABanner } from "../components/Shared";
import IntroLoader from "../components/IntroLoader";

const HomePage = () => (
  <main data-testid="home-page">
    <IntroLoader />
    <Hero />
    <TrustStrip />
    <AboutSection />
    <ServicesSection />
    <CapabilitiesSection />
    <QualitySection />
    <CommitmentSection />
    <ClientsSection />
    <CTABanner
      title="Let's Bring Your Next Print Project to Life."
      text="Share your requirements — our team will respond with a considered, transparent quote."
    />
  </main>
);

export default HomePage;
